// extracted by mini-css-extract-plugin
export default {"mCard":"aA-z","image":"bA-z","imageNoBackground":"cA-z","imageHasCategory":"dA-z","fullWidth":"eA-z"};